import Grid from "components/primitives/Grid";
import type { GridProps } from "components/primitives/Grid";

/**
 * @description PageHeader is a styled Grid component that serves as the header for the page layout.
 */
function PageHeader(props: GridProps) {
  const { sx, ...rest } = props;
  return (
    <Grid
      container
      sx={{
        alignItems: "center",
        bgcolor: "common.white",
        height: 80,
        px: 3,
        boxShadow: 6,
        ...sx,
      }}
      {...rest}
    />
  );
}

export default PageHeader;
